export default __webpack_public_path__ + "static/media/thumb.d4b91d07.png";